module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lessons__filters"
  }, [_c('Tabs', {
    attrs: {
      "tabs": _vm.tabsList,
      "selected": _vm.activeFilter
    },
    on: {
      "select": _vm.setFilter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b700d4fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalaryFilters.vue
// module id = 2100
// module chunks = 1